import React from 'react'

export default function Contact() {
  return (
    <div className="container contact">
      <h1 className='formtext '>Please contact us !</h1><br/><br/>
   <div className="formulaire">
    <br/> 
   
     
      <form  action="https://formsubmit.co/e306636959462a543e34ddb845694d6f"  target="_blank"  method="POST">
             
             <input type="hidden" name="_subject" value="New Email has come !" />
             <input type="hidden" name="_next" value="https://coffeecornr.netlify.app/thankyou" />
               <label>Full Name</label> <br/><br/>
             <input className="text" type="text" placeholder="Your Full name" name="fullname" autofocus required /><br/>
             <label>Your number</label> <br/><br/>
             <input className="text" type="number" placeholder="+509 2000-2568" name="phone" required /><br/>
             <label>E-mail</label> <br/><br/>
             <input className="email" type="email" placeholder="youremail@yhoo.fr" name="email" required  /><br/><br/>
             <label>Write your message</label> <br/><br/>
           <textarea className="textarea" cols="40" rows="10"  name="message" placeholder="Your Message" required  ></textarea><br/><br/>
          <button className="btn btn-form btn-dark" type="submit">Submit</button><br/><br/>
         
       </form>
    
</div>


</div>
  )
}
